(ns common.uix.hooks
  (:require ["react-use/lib/useCopyToClipboard$default" :as useCopyToClipboard]
            [common.re-frame :as cr]
            [re-frame.core :as rf]
            [reagent.ratom :as ratom]
            [uix.core :as uix :refer [defhook]]))

;;
;; State hook which stores the state to re-frame db.
;; Workaround until Reagent gets React Refresh support.
;;

(rf/reg-sub ::value
  (fn [db [_ path]]
    (get-in db path ::missing)))

(rf/reg-event-db ::set-value
  (fn [db [_ path new-value]]
    (assoc-in db path new-value)))

(defn use-state [{:keys [initial-value path]}]
  ;; Can't use defhook because rf/subscribe call
  (let [initial-rf-value (binding [ratom/*ratom-context* nil]
                           @(cr/no-warning-subscribe [::value path]))
        [value set-value*] (uix/use-state (if (= ::missing initial-rf-value)
                                            initial-value
                                            initial-rf-value))
        set-value (uix/use-callback (fn [new-value-or-f]
                                      (if (fn? new-value-or-f)
                                        (set-value* (fn [old]
                                                      (let [new (new-value-or-f old)]
                                                        (rf/dispatch [::set-value path new])
                                                        new)))
                                        (do
                                          (set-value* new-value-or-f)
                                          (rf/dispatch [::set-value path new-value-or-f]))))
                                    ;; Cljs vector of keywords has different identity each render
                                    ;; hash could be fast but not 100% accurate
                                    ;; in this case path should be a quite small value, so pr-str is hopefully fast enough
                                    ^:lint/disable
                                    [(pr-str path)])]
    [value set-value]))

(defn use-has-overflow []
  (let [ref (uix/use-ref nil)
        [is-overflow set-is-overflow] (uix/use-state js/undefined)]
    (uix/use-layout-effect (fn []
                             (let [current (.-current ref)
                                   trigger (fn []
                                             (let [has-overflow (> (.-scrollHeight current)
                                                                   (.-clientHeight current))]
                                               (set-is-overflow has-overflow)))]
                               (when current
                                 (let [obs (js/ResizeObserver. trigger)]
                                   (.observe obs current)
                                   (trigger)
                                   (fn []
                                     (.disconnect obs))))))
                           [])
    [ref is-overflow]))

(defhook use-element-presence [selector]
  (let [[is-element-present set-is-element-present] (use-state false)]
    (uix/use-effect (fn []
                      (let [check-element-presence (fn []
                                                     (let [element (.querySelector js/document selector)]
                                                       (set-is-element-present (boolean element))))]

                        ;; Initial check
                        (check-element-presence)

                        ;; Create a MutationObserver to watch for DOM changes
                        (let [observer (js/MutationObserver. check-element-presence)]
                          ;; Observe the whole document for childList and subtree changes
                          (.observe observer js/document (clj->js {:childList true :subtree true}))

                          ;; Cleanup the observer on component unmount
                          (fn []
                            (.disconnect observer))))))
    is-element-present))

(defhook use-copy-with-toaster [{:keys [success-message]}]
  (let [[^js state copy-to-clipboard] (useCopyToClipboard)
        copy-value (.-value state)]
    (uix/use-effect (fn []
                      (when copy-value
                        (rf/dispatch [:toaster-bus/add {:type :success
                                                        :message success-message}])))
                    [copy-value success-message])
    copy-to-clipboard))
